import React, { FC, useCallback, useState } from 'react';
import { BottomBar, Button, Form, FormItem, Header, Input, ScrollView } from '$uikit';
import { useTranslator } from '$hooks';
import { useDispatch } from 'react-redux';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { cloudActions } from '$store/cloud';
import { goBack } from '$navigation/helper';

export const CloudNewAlbum: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const [title, setTitle] = useState('');

  const handleTitleChange = useCallback(
    ({ target }) => {
      setTitle(target.value);
    },
    [setTitle],
  );

  const handleSave = useCallback(() => {
    dispatch(toastActions.setToastLoading());
    Api.post<any, any>('/albums/create', {
      title: title.trim(),
    })
      .then((data) => {
        dispatch(toastActions.setToastSuccess());
        dispatch(cloudActions.addNewAlbum(data.album));
        goBack();
      })
      .catch((err) => {
        dispatch(toastActions.setToastFail(err.message));
      });
  }, [title]);

  return (
    <>
      <Header showCloseButton>{t('cloud_new_album_title')}</Header>
      <ScrollView>
        <Form>
          <FormItem title={t('cloud_new_album_name')}>
            <Input
              placeholder={t('cloud_new_album_name_placeholder')}
              value={title}
              onChange={handleTitleChange}
            />
          </FormItem>
        </Form>
      </ScrollView>
      <BottomBar>
        <Button stretched onClick={handleSave}>
          {t('save')}
        </Button>
      </BottomBar>
    </>
  );
};
